import merge from 'deepmerge'
import { createGettext } from 'vue3-gettext'
import { getCookie } from '@/helpers/cookie'
import extractedTranslations from '@/language/extracted/translations.json'
import additionalTranslations from '@/language/additionals/translations.json'

const translations = merge(
  extractedTranslations,
  additionalTranslations,
)

export default createGettext({
  availableLanguages: {
    de: 'Deutsch',
    en: 'English',
    es: 'Español',
    fr: 'Français',
    pt: 'Português',
  },
  defaultLanguage: getCookie('DittoMusic[lang]') || 'en',
  mutedLanguages: ['en'],
  translations,
})
